<template>
  <div class="price-table">
    <div class="well price-breakdown">
      <div class="row">
        <div class="col-xs-5"><strong>Description</strong></div>
        <div class="col-xs-2"><strong>Units</strong></div>
        <div class="col-xs-3"><strong>Cost</strong></div>
        <div class="col-xs-2"><strong>Total</strong></div>
      </div>
      <div class="row">
        <div class="col-xs-5">Daily Rate</div>
        <div class="col-xs-2">{{ priceBreakdown.cost.days }}</div>
        <div class="col-xs-3">
          {{ priceBreakdown.rate.dailyRate | currency_round }}/day
        </div>
        <div class="col-xs-2">
          {{ priceBreakdown.cost.dailySubTotal | currency_round }}
        </div>
      </div>
      <div class="row">
        <div class="col-xs-5">Hourly Rate</div>
        <div class="col-xs-2">{{ priceBreakdown.cost.hours }}</div>
        <div class="col-xs-3">
          {{ priceBreakdown.rate.hourlyRate | currency_round }}/hr
        </div>
        <div class="col-xs-2">
          {{ priceBreakdown.cost.hourlySubTotal | currency_round }}
        </div>
      </div>
      <div class="row" v-if="priceBreakdown.cost.overnightSubTotal > 0">
        <div class="col-xs-5">Overnight Rate (5pm - 8am)</div>
        <div class="col-xs-2">{{ priceBreakdown.cost.overnightHours }}</div>
        <div class="col-xs-3">
          {{ priceBreakdown.rate.overnightRate | currency_round }}
        </div>
        <div class="col-xs-2">
          {{ priceBreakdown.cost.overnightSubTotal | currency_round }}
        </div>
      </div>
      <div class="row" v-if="priceBreakdown.cost.weekendSubTotal > 0">
        <div class="col-xs-5">Weekend Rate</div>
        <div class="col-xs-2">{{ priceBreakdown.cost.weekendDays }}</div>
        <div class="col-xs-3">
          {{ priceBreakdown.rate.weekendRate | currency_round }}
        </div>
        <div class="col-xs-2">
          {{ priceBreakdown.cost.weekendSubTotal | currency_round }}
        </div>
      </div>
      <!-- displaying extras in modifying reservation -->
      <template v-if="priceBreakdown.reservation.uuid">
        <template v-for="extra in priceBreakdown.reservation.extras">
          <template v-if="extra.rateType === 'fixed'">
            <div class="row">
              <div class="col-xs-5">{{ extra.name }}</div>
              <div class="col-xs-2">1</div>
              <div class="col-xs-3">{{ extra.cost | currency_round }}</div>
              <div class="col-xs-2">{{ extra.cost | currency_round }}</div>
            </div>
          </template>
          <template v-if="extra.rateType === 'rate'">
            <div class="row">
              <div class="col-xs-5">{{ extra.name }} (Daily Rate)</div>
              <div class="col-xs-2">{{ priceBreakdown.cost.days }}</div>
              <div class="col-xs-3">{{ extra.dailyRate | currency_round }}/day</div>
              <div class="col-xs-2">
                {{ extra.dailyRate * priceBreakdown.cost.days | currency_round }}
              </div>
            </div>
            <div class="row">
              <div class="col-xs-5">{{ extra.name }} (Hourly Rate)</div>
              <div class="col-xs-2">
                {{ priceBreakdown.cost.hours }}
              </div>
              <div class="col-xs-3">{{ extra.hourlyRate | currency_round }}/hr</div>
              <div class="col-xs-2">
                {{ extra.hourlyRate * priceBreakdown.cost.hours
                   | currency_round }}
              </div>
            </div>
            <div class="row" v-if="priceBreakdown.cost.overnightSubTotal > 0">
              <div class="col-xs-5">{{ extra.name }} (Overnight Rate)</div>
              <div class="col-xs-2">{{ priceBreakdown.cost.overnightHours }}</div>
              <div class="col-xs-3">{{ extra.overnightRate | currency_round }}</div>
              <div class="col-xs-2">
                {{ extra.overnightRate * priceBreakdown.cost.overnightHours |
                  currency_round }}
              </div>
            </div>
            <div class="row" v-if="priceBreakdown.cost.weekendSubTotal > 0">
              <div class="col-xs-5">{{ extra.name }} (Weekend Rate)</div>
              <div class="col-xs-2">{{ priceBreakdown.cost.weekendDays }}</div>
              <div class="col-xs-3">{{ extra.weekendRate | currency_round }}</div>
              <div class="col-xs-2">
                {{ extra.weekendRate * priceBreakdown.cost.weekendDays |
                  currency_round }}
              </div>
            </div>
          </template>
        </template>
      </template>
      <!-- selected extras when creating new reservation -->
      <template v-if="!priceBreakdown.reservation.uuid">
        <template v-for="extra in priceBreakdown.extras">
          <template v-if="extra.rateType === 'fixed'">
            <div class="row">
              <div class="col-xs-5">{{ extra.name }}</div>
              <div class="col-xs-2">1</div>
              <div class="col-xs-3">{{ extra.cost | currency_round }}</div>
              <div class="col-xs-2">{{ extra.cost | currency_round }}</div>
            </div>
          </template>
          <template v-if="extra.rateType === 'rate'">
            <div class="row">
              <div class="col-xs-5">{{ extra.name }} (Daily Rate)</div>
              <div class="col-xs-2">{{ priceBreakdown.cost.days }}</div>
              <div class="col-xs-3">{{ extra.dailyRate | currency_round }}/day</div>
              <div class="col-xs-2">
                {{ extra.dailyRate * priceBreakdown.cost.days | currency_round }}
              </div>
            </div>
            <div class="row">
              <div class="col-xs-5">{{ extra.name }} (Hourly Rate)</div>
              <div class="col-xs-2">
                {{ priceBreakdown.cost.hours }}
              </div>
              <div class="col-xs-3">{{ extra.hourlyRate | currency_round }}/hr</div>
              <div class="col-xs-2">
                {{ extra.hourlyRate * priceBreakdown.cost.hours
                   | currency_round }}
              </div>
            </div>
            <div class="row" v-if="priceBreakdown.cost.overnightSubTotal > 0">
              <div class="col-xs-5">{{ extra.name }} (Overnight Rate)</div>
              <div class="col-xs-2">{{ priceBreakdown.cost.overnightHours }}</div>
              <div class="col-xs-3">{{ extra.overnightRate | currency_round }}</div>
              <div class="col-xs-2">
                {{ extra.overnightRate * priceBreakdown.cost.overnightHours |
                  currency_round }}
              </div>
            </div>
            <div class="row" v-if="priceBreakdown.cost.weekendSubTotal > 0">
              <div class="col-xs-5">{{ extra.name }} (Weekend Rate)</div>
              <div class="col-xs-2">{{ priceBreakdown.cost.weekendDays }}</div>
              <div class="col-xs-3">{{ extra.weekendRate | currency_round }}</div>
              <div class="col-xs-2">
                {{ extra.weekendRate * priceBreakdown.cost.weekendDays | currency_round }}
              </div>
            </div>
          </template>
        </template>
      </template>
      <div class="row">
        <hr class="total-bar"/>
        <div class="col-xs-10"><strong>{{ showDetails || priceBreakdown.cost.percentDiscount > 0  ? 'Sub Total' : 'Total' }}</strong></div>
        <div class="col-xs-2">
          <strong>{{ priceBreakdown.cost.preDiscountCost || priceBreakdown.cost.subTotalCost | currency_round }}</strong>
        </div>
      </div>
      <div class="row" v-if="priceBreakdown.cost.percentDiscount > 0">
        <div class="col-xs-10"><strong>Discount</strong></div>
        <div class="col-xs-2">
          <strong class="credit">
            <em>{{ priceBreakdown.cost.percentDiscount }}% off*</em>
          </strong>
        </div>
      </div>
      <div class="row" v-if="!showDetails && priceBreakdown.cost.percentDiscount > 0">
        <hr class="total-bar"/>
        <div class="col-xs-10"><strong>Total</strong></div>
        <div class="col-xs-2">
          <strong>{{ priceBreakdown.cost.subTotalCost | currency_round }}</strong>
        </div>
      </div>
      <template v-if="showDetails">
      <div class="row" v-if="priceBreakdown.cost.extraCredit > 0">
        <div class="col-xs-10"><strong>Credit</strong></div>
        <div class="col-xs-2">
          <strong class="credit">
            {{ priceBreakdown.cost.extraCredit | currency_round }}
          </strong>
        </div>
      </div>
      <div class="row" v-if="priceBreakdown.reservation.quotedCost > 0">
        <div class="col-xs-10"><strong>Already Paid</strong></div>
        <div class="col-xs-2">
          <strong class="already-paid">
            {{ priceBreakdown.cost.alreadyPaid | currency_round }}
          </strong>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-10"><strong>Account Credit</strong></div>
        <div class="col-xs-2">
          <strong v-bind:class="{
            'red': priceBreakdown.cost.originalCredit < 0, 'credit': priceBreakdown.cost.originalCredit > 0 }">
            {{ priceBreakdown.cost.originalCredit | currency_round_neg }}</strong>
        </div>
      </div>
      <div v-if="priceBreakdown.cost.originalCredit < 0 && priceBreakdown.rate.hourlyRate > 0 && priceBreakdown.rate.dailyRate > 0" class="row">
        <hr class="total-bar"/>
        <div class="col-xs-10"><strong>Account Balance Payment</strong></div>
        <div class="col-xs-2">
          <strong>{{ Math.abs(priceBreakdown.cost.originalCredit) | currency_round_neg }}</strong>
        </div>
      </div>
      <div class="row">
        <hr class="total-bar"/>
        <div class="col-xs-10"><strong>Total</strong></div>
        <div class="col-xs-2">
          <strong>{{ priceBreakdown.cost.totalCost | currency_round }}</strong>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-10"><strong>Remaining Credits</strong></div>
        <div class="col-xs-2">
          <strong v-bind:class="{
            'red': priceBreakdown.cost.remainingCredit < 0, 'credit': priceBreakdown.cost.remainingCredit > 0 }">
            {{ priceBreakdown.cost.remainingCredit | currency_round_neg }}</strong>
        </div>
      </div>
    </template>
    <div class="row" v-if="priceBreakdown.cost.percentDiscount > 0">
      <div class="col-xs-10"><strong>You Save</strong></div>
      <div class="col-xs-2">
        <strong class="credit">
          <em>{{ priceBreakdown.cost.preDiscountCost - priceBreakdown.cost.subTotalCost | currency_round }}</em>
        </strong>
      </div>
    </div>
    </div>
    <p v-if="priceBreakdown.cost.percentDiscount > 0">
      * Discount does not apply on any optional extras, parking levies, tolls, kilometres travelled or already discounted rates (overnight and weekend rates).
    </p>
  </div>
</template>

<script>
export default {
  name: 'PriceTable',
  data () {
    return {}
  },
  props: {
    priceBreakdown: {
      type: Object,
      default () {
        return {
          reservation: {},
          cost: {},
          rate: {}
        }
      }
    },
    showDetails: {
      type: Boolean,
      default () {
        return true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// PriceTable.vue?7598604f